import httpEpayment from "./axios/http-epayment";
import { withBrowserAuth } from "./browser-session";

class Epayment {
  constructor() {
    this.dataMerchRefNo = "/transaction_data_via_merchantrefno";
    this.paymentReqAccess = "/access";
  }

  getTransactionData_merchRefNo(data, options = {}) {
    return httpEpayment.post(
      this.dataMerchRefNo,
      data,
      withBrowserAuth(options),
    );
  }

  paymentRequestAccess(data) {
    return httpEpayment.post(this.paymentReqAccess, data, withBrowserAuth());
  }
}

export default new Epayment();
